<template>
    <form class="form-v"
          style="width: 400px;">
        <div class="form-group">
            <div class="control-label">
                <label>This is MultiSelect component</label>
            </div>
            <MultiSelect name="fruit-and-veg"
                         :initial-options="groupedOptions"
                         :selected-option-ids="selectedOptions"
                         @update:selected-options="alertOptions" />
        </div>
    </form>
</template>

<script>
import MultiSelect from '@/vue/components/Forms/MultiSelect';

export default {
    components: { MultiSelect },

    data() {
        return {
            // Example structure - keep this for the tests.
            groupedOptions: {
                Fruits: [
                    { name: 'Apple', ID: 100 },
                    { name: 'Banana', ID: 22 },
                    { name: 'Mango', ID: 31 },
                    { name: 'Raspberry', ID: 42 },
                    { name: 'Strawberry', ID: 5 },
                ],
                Vegetables: [
                    { name: 'Aubergine', ID: 6 },
                    { name: 'Carrot', ID: 7 },
                    { name: 'Lettuce', ID: 88 },
                    { name: 'Bean', ID: 99 },
                ],
            },

            selectedOptions: [],
        };
    },

    methods: {
        alertOptions(options) {
            console.log('selectedOptions: ', options);
        },
    },
};
</script>
